<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card style="display: flex; flex-direction: column; margin-top: 20px">
        <v-card-title>
          <h2 class="pl-2">
            {{
              editedIndex == -1
                ? "Create store food category"
                : "Edit store food category"
            }}
          </h2>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-text>
          <v-form ref="formStoreCategory" v-model="valid">
            <div
              style="display: flex; padding-block: 10px; padding-inline: 20px"
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <img
                    :src="newImageSrc"
                    :style="{
                      width: '150px',
                      height: '150px',
                      border: '1px solid gray',
                    }"
                    style="border-radius: 15px"
                    alt="Cropped Image"
                    v-if="newImageSrc"
                  />
                  <v-card
                    @click="$refs.ProfileInput.click()"
                    height="150px"
                    width="150px"
                    color="grey"
                    style="
                      border-radius: 15px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                    v-else-if="form.store_category_image == null"
                  >
                    <v-icon color="white">add</v-icon>
                  </v-card>
                  <img
                    :src="form.store_category_image"
                    :style="{
                      width: '150px',
                      height: '150px',
                      border: '1px solid gray',
                    }"
                    style="border-radius: 15px"
                    alt="Cropped Image"
                    v-else
                  />

                  <input
                    style="display: none"
                    type="file"
                    @change="onProfileImageSelected"
                    ref="ProfileInput"
                    accept="image/jpg, image/jpeg"
                  />
                  <div style="margin-bottom: 20px"></div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                    v-if="
                      (newImageSrc && newImageSrc != null) ||
                      form.store_category_image != null
                    "
                  >
                    <v-btn @click="$refs.ProfileInput.click()" color="info"
                      >Edit Image</v-btn
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout wrap>
                    <v-flex md12 xs12>
                      <v-text-field
                        label="Store Food Category Name (Thai)"
                        required
                        v-model="form.store_category_name_th"
                        :rules="[
                          (v) => !!v || 'required',
                          (v) =>
                            v.length <= 255 || 'name must be less than 255',
                        ]"
                        counter="255"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex md12 xs12>
                      <v-text-field
                        label="Store Food Category Name (English)"
                        required
                        v-model="form.store_category_name_en"
                        :rules="[
                          (v) => !!v || 'required',
                          (v) =>
                            v.length <= 255 || 'name must be less than 255',
                        ]"
                        counter="255"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <v-dialog v-model="store_images_dialog" max-width="65vw">
              <v-card>
                <imageCropper
                  :aspectRatio="480 / 480"
                  :imageName="selectedFile.store_img_name"
                  :imgSrc="storeImageTemp"
                  :height="300"
                  @close="store_images_dialog = false"
                  @setImageName="selectedFile.store_img_name = $event"
                  @getCroped="getProfileCropped($event)"
                  v-if="storeImageTemp != ''"
                ></imageCropper>
              </v-card>
            </v-dialog>
          </v-form>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isSubmit"
            @click="$emit('onClosed')"
            flat
            color="error"
          >
            Cancel
          </v-btn>
          <v-btn :loading="isSubmit" @click="submit()" flat color="success">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_dialog" persistent max-width="500">
      <v-card>
        <div
          style="
            background-color: #fddf00;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
          "
        >
          <v-icon large style="margin-right: 10px" color="black"
            >warning</v-icon
          >
          <div style="font-size: 1.8rem">Warning</div>
        </div>
        <v-card-title class="headline" primary-title>{{
          error_text
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="failed_dialog" max-width="350">
      <v-card style="border-radius: 20px">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-block: 30px;
          "
        >
          <v-icon
            x-large
            style="margin-bottom: 10px; font-size: 70px"
            color="red"
            >close</v-icon
          >
          <div style="font-size: 1.8rem">Update Failed</div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="failed_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import imageUploader from "@/components/back-office/StoreManagement/ImageUploader.vue";
export default {
  props: ["store_type_data", "dialog", "editedIndex", "selectedItem"],
  data: () => ({
    form: {
      store_category_name_th: "",
      store_category_name_en: "",
      store_category_image: null,
      store_category_status: 0,
    },
    isSubmit: false,
    error_dialog: false,
    store_images_dialog: false,
    failed_dialog: false,
    change_image: 0,
    height: 300,
    storeImageTemp: "",
    error_text: "",
    selectedFile: {
      store_img: "",
      store_img_name: "",
    },
    newImageSrc: null,
    storeStatus: false,
    storeNameRules: [
      (v) => {
        if (v === "") {
          return "Store type name is required";
        } else {
          return true;
        }
      },
    ],
    valid: true,
  }),
  components: { imageCropper, imageUploader },
  watch: {
    dialog() {
      if (this.dialog == true) {
        if (this.editedIndex == -1) {
          this.resetForm();
          this.$refs.form.resetValidation();
        } else {
          let result = JSON.parse(JSON.stringify(this.selectedItem));
          this.form = {
            store_category_id: result.store_category_id,
            store_category_name_th: result.store_category_name_th,
            store_category_name_en: result.store_category_name_en,
            store_category_image: result.store_category_image,
            store_category_status: result.store_category_status,
          };
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        store_category_name_th: "",
        store_category_name_en: "",
        store_category_image: null,
        store_category_status: 0,
      };
      this.newImageSrc = null;
    },
    getProfileCropped(image_value) {
      this.newImageSrc = image_value;
      this.selectedFile = { store_img: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    openDeleteStoreImageIndex(index) {
      this.deleteImgDialog = true;
      this.deleteImageIndex = index;
    },
    onProfileImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async updateDineInStore() {
      if (this.newImageSrc === "") {
        this.error_text = "Please upload store type image.";
        this.error_dialog = true;
        return;
      }
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStoreType",
        payload
      );
      if (res === false) {
        this.failed_dialog = true;
      } else {
        this.$emit("closeEditDialog");
        this.resetData();
      }
    },
    resetData() {
      this.storeImageTemp = "";
      this.error_text = "";
      this.newImageSrc = null;
      this.storeStatus = false;
    },
    submit() {
      if (!this.$refs.formStoreCategory.validate()) return;
      let payload = JSON.parse(JSON.stringify(this.form));
      if (this.newImageSrc != null) {
        payload.store_category_image = this.newImageSrc;
      } else {
        delete payload.store_category_image;
      }

      let _this = this;
      this.isSubmit = true;

      this.$emit("onSubmit", {
        done() {
          _this.isSubmit = false;
        },
        form: payload,
      });
    },
  },
};
</script>
<style scoped>
.info-header {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
}
</style>
